module.exports = __webpack_public_path__ + "static/media/demiguise.a94c5452.png";